import axios from 'axios';
import { API_BASE } from './config';

/**
 * Fetch all coin networks
 * @param networkId Optional network ID filter
 * @param coinId Optional coin ID filter
 * @returns List of coin networks
 */
export const fetchCoinNetworks = async (networkId?: string, coinId?: string) => {
  const params: any = {};
  if (networkId) params.network_id = networkId;
  if (coinId) params.coin_id = coinId;

  const response = await axios.get(`${API_BASE}/coin-network`, { params });
  return response.data.data;
};

/**
 * Fetch a coin network by ID
 * @param id Coin network ID
 * @returns Coin network details
 */
export const fetchCoinNetworkById = async (id: string) => {
  const response = await axios.get(`${API_BASE}/coin-network/${id}`);
  return response.data.data;
};

/**
 * Check if a coin network exists
 * @param coinSymbol Coin symbol
 * @param networkTitle Network title
 * @returns Coin network if exists, empty array otherwise
 */
export const checkCoinNetwork = async (coinSymbol: string, networkTitle: string) => {
  const response = await axios.get(`${API_BASE}/coin-network/check`, {
    params: { coin: coinSymbol, network: networkTitle }
  });
  return response.data.data;
};

/**
 * Create a new coin network
 * @param coinNetworkData Coin network data
 * @returns Created coin network
 */
export const createCoinNetwork = async (coinNetworkData: any) => {
  // Ensure creator_id is a number and not null
  if (coinNetworkData.creator_id === null || coinNetworkData.creator_id === undefined) {
    console.warn('creator_id is null or undefined, setting default value');
    coinNetworkData.creator_id = 123;
  }

  // Log the payload before sending
  console.log('API call payload before sending:', JSON.stringify(coinNetworkData, null, 2));

  const response = await axios.post(`${API_BASE}/coin-network`, coinNetworkData);
  return response.data.data;
};

/**
 * Update a coin network
 * @param id Coin network ID
 * @param coinNetworkData Updated coin network data
 * @returns Updated coin network
 */
export const updateCoinNetwork = async (id: string, coinNetworkData: any) => {
  // Ensure creator_id is a number and not null
  if (coinNetworkData.creator_id === null || coinNetworkData.creator_id === undefined) {
    console.warn('creator_id is null or undefined in update, setting default value');
    coinNetworkData.creator_id = 123;
  }

  // Log the payload before sending
  console.log('API update payload before sending:', JSON.stringify(coinNetworkData, null, 2));

  const response = await axios.put(`${API_BASE}/coin-network/${id}`, coinNetworkData);
  return response.data.data;
};

/**
 * Delete a coin network
 * @param id Coin network ID
 * @returns Response data (for soft delete) or void (for hard delete)
 */
export const deleteCoinNetwork = async (id: string) => {
  try {
    const response = await axios.delete(`${API_BASE}/coin-network/${id}`);
    // If the response has data (soft delete case), return it
    if (response.status === 200 && response.data && response.data.data) {
      return response.data.data;
    }
    // Otherwise, it's a hard delete (204 No Content)
    return null;
  } catch (error: any) {
    // If the error response contains data (soft delete case), return it
    if (error.response && error.response.status === 200 &&
        error.response.data && error.response.data.data) {
      return error.response.data.data;
    }
    // Otherwise, rethrow the error
    throw error;
  }
};
